import classNames from "classnames";
import { HistoricReturnChart } from "src/components/__consumerCharts/HistoricReturnChart/HistoricReturnChart";
import { useParams } from "react-router-dom";
import { ConnectedInformationButton } from "src/main";
import s from "./DailyReturnsWidget.module.scss";
import { useHistoricRiskData } from "src/components/__pageComponents/RiskPage/useRiskPageSummary";
import { useReportBespoke, useReportContext } from "@iliotech/data-wire";
import { ReportWidgetProps } from "../../ReportWidgetProps";
import { observer } from "mobx-react-lite";

export const DailyReturnsWidget = observer(
  ({ height, width, periodContext }: ReportWidgetProps) => {
    const { portfolioId } = useParams<{ portfolioId: string }>();
    const periodString = periodContext.periodString;
    const store = useReportBespoke();
    const { generating } = store;
    const historicData = useHistoricRiskData({
      isMonthly: false,
      portfolioId: portfolioId!,
      overridePeriod: periodContext.periodForRequest,
    });

    return (
      <div>
        <ConnectedInformationButton code={"riskHistoricReturn"}>
          <h3 className={classNames("element-title")}>
            {`Distribution of Daily Returns`}
          </h3>
        </ConnectedInformationButton>
        <p className={"period-string"}>{periodString}</p>
        <HistoricReturnChart
          height={height}
          width={width}
          {...historicData}
          generating={generating}
        />
      </div>
    );
  }
);
